import React from 'react';

export const DownArrow = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0L5 5L10 0H0Z"
      fill={color || 'black'}
      fillOpacity="0.87"
    />
  </svg>
);
